import { CONSTANT_TEXTS } from '@gp/constants/const';
import { CommonColumnBuilders } from '@gp/utils/columns';
import { getRecordKeyOfMockable } from '@gp/utils/common';
import { formatMilestoneDateByStatus } from '@gp/utils/milestone';
import classnames from 'classnames';
import React, { useMemo } from 'react';
import { Table, TableColumn } from 'tea-component';
import ReportCard from '../../components/ReportCard';
import { buildProjectColumn } from '../../utils/columns';
import {
  COMMON_COLUMN_WIDTH,
  MILESTONE_COLUMN_WIDTH,
  MILESTONE_DATE_COLUMN_WIDTH,
  PROJECT_COLUMN_WIDTH,
  STATUS_COLUMN_WIDTH,
} from './constants';
import { CARD_TITLE } from './utils';

import type { IDPSReportCalendarVO } from '@gp/types/dpsReport/common';
import type { IRecord } from '@gp/types/global';
import type { IBaseProps } from '@home/types/common';

export interface IReviewCalendarProps extends IBaseProps {
  moduleKey?: string;
  columnWidthMapping?: IRecord<string | undefined>;
  // 标题
  title?: string | React.ReactElement | null;
  // 模块数据
  value: IDPSReportCalendarVO[];
}

const ReviewCalendar: React.FC<IReviewCalendarProps> = (props) => {
  const {
    style,
    className,
    moduleKey,
    columnWidthMapping,
    title = CARD_TITLE,
    value: records,
  } = props;

  const columns = useMemo<TableColumn<IDPSReportCalendarVO>[]>(
    () => [
      // CommonColumnBuilders.buildPureTextColumn({
      //   key: 'priority',
      //   header: 'Priority',
      //   width: columnWidthMapping?.priority ?? PRIORITY_COLUMN_WIDTH,
      //   formatter: (cvm) => {
      //     const { priority } = cvm || {};
      //     return <MorePriorityTag showIcon={false} value={priority} />;
      //   },
      // }),
      buildProjectColumn({ width: columnWidthMapping?.project_id ?? PROJECT_COLUMN_WIDTH }),
      CommonColumnBuilders.buildPureTextColumn({
        key: 'business_owner',
        header: 'BO',
        width: columnWidthMapping?.business_owner ?? COMMON_COLUMN_WIDTH,
      }),
      CommonColumnBuilders.buildPureTextColumn({
        key: 'pteam',
        header: 'P-team',
        width: columnWidthMapping?.pteam ?? COMMON_COLUMN_WIDTH,
      }),
      CommonColumnBuilders.buildPureTextColumn({
        key: 'milestone',
        header: CONSTANT_TEXTS.MILESTONE,
        width: columnWidthMapping?.milestone ?? MILESTONE_COLUMN_WIDTH,
      }),
      CommonColumnBuilders.buildPureTextColumn({
        key: 'date',
        header: CONSTANT_TEXTS.MILESTONE_TIME,
        width: columnWidthMapping?.date ?? MILESTONE_DATE_COLUMN_WIDTH,
        formatter: (cvm) => formatMilestoneDateByStatus(cvm?.date, cvm?.date_confirm),
      }),
      CommonColumnBuilders.buildPureTextColumn({
        key: 'status',
        header: 'Status',
        width: columnWidthMapping?.status ?? STATUS_COLUMN_WIDTH,
      }),
    ],
    [],
  );

  return (
    <ReportCard
      style={style}
      className={classnames('dbg-dps-report__calendars-table-card', className)}
      moduleKey={moduleKey}
      title={title}
    >
      <Table
        className="dbg-dps-report__boeder-table"
        columns={columns}
        records={records}
        recordKey={getRecordKeyOfMockable}
      />
    </ReportCard>
  );
};

export default ReviewCalendar;
